import { JSX } from 'react';
import { InView } from 'react-intersection-observer';

import { PartCircleIcon } from '@src/components/icons/part-circle';
import { ProvidedByTrupanionLogo } from '@src/components/icons/trupanion';
import { LemonadeSVG } from '@src/pages/landing/components/icons/lemonade-logo';

export default function Teams({
  descendants,
  analytics,
  onSectionView,
}: {
  descendants: {
    title: string | JSX.Element;
  }[][];
  analytics: {
    label: string;
    value: string;
  };
  onSectionView: (
    label: string,
    value: string,
    extraData?: Record<string, string>,
  ) => void;
}): JSX.Element {
  return (
    <section className="pi-careplus__teams">
      <div className="pi-careplus__teams__trupanion--content">
        <div className="pi-careplus__teams__trupanion--partner">
          <InView
            as="div"
            triggerOnce={true}
            onChange={(inView: boolean) => {
              if (!inView) return;
              onSectionView(analytics.label, analytics.value);
            }}
          >
            <ProvidedByTrupanionLogo fill="#fff" />
          </InView>
        </div>
        <ul className="pi-careplus__teams__trupanion--cards">
          {descendants[0].map(
            (
              {
                title,
              }: {
                title: string | JSX.Element;
              },
              i: number,
            ): JSX.Element => {
              const name = `pi-careplus__teams__trupanion--card-${i}`;
              return (
                <li
                  key={name}
                  className={`pi-careplus__teams__trupanion--card ${name}`}
                >
                  <div className="pi-careplus__teams__trupanion--icon">
                    <PartCircleIcon />
                  </div>
                  <p className="pi-careplus__teams__trupanion--subtext">
                    {title}
                  </p>
                </li>
              );
            },
          )}
        </ul>
      </div>
      <div className="pi-careplus__teams__lemonade--content">
        <div className="pi-careplus__teams__lemonade--partner">
          <InView
            as="div"
            triggerOnce={true}
            onChange={(inView: boolean) => {
              if (!inView) return;
              onSectionView(analytics.label, analytics.value);
            }}
          >
            <div className="pi-careplus__teams__lemonade--partner-icon">
              <LemonadeSVG />
            </div>
          </InView>
        </div>
        <ul className="pi-careplus__teams__lemonade--cards">
          {descendants[1].map(
            (
              {
                title,
              }: {
                title: string | JSX.Element;
              },
              i: number,
            ): JSX.Element => {
              const name = `pi-careplus__teams__lemonade--card-${i}`;
              return (
                <li
                  key={name}
                  className={`pi-careplus__teams__lemonade--card ${name}`}
                >
                  <div className="pi-careplus__teams__lemonade--icon">
                    <PartCircleIcon fill="#FF0083" />
                  </div>
                  <p className="pi-careplus__teams__lemonade--subtext">
                    {title}
                  </p>
                </li>
              );
            },
          )}
        </ul>
      </div>
    </section>
  );
}
